































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalRegraGarantiaMinimaIncluir from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalRegraGarantiaMinimaIncluir.vue'
import ModalCadastroHospitaisGarantiaMinimaGlobal from '@/components/RemuneracaoMedica/suporte/components/ModalCadastroHospitaisGarantiaMinimaGlobal.vue'
import EventBus from '@/plugins/EventBus'

@Component({
  components: {
    ModalRegraGarantiaMinimaIncluir,
    ModalCadastroHospitaisGarantiaMinimaGlobal,
  },
})
export default class ModalFinanceiroRegraGarantiaMinimaGlobal extends Vue {
  $refs!: { tabs: any }
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get mode() { return this.getRegrasDeCalculoStore.mode }
  get showModal() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGarantiaMinima }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGarantiaMinima', value }) }

  /** TABS */

  tb: string = 'tab-1'
  get tabs() { return this.tb }
  set tabs(value: string) { this.tb = value }

  async tabChange(e: string) {
    let tab = ''
    switch (e) {
      case 'tab-1':
        tab = 'garantia'
        break
      case 'tab-2':
        tab = 'hospitais'
        break
      default:
        tab = 'garantia'
    }

    this.$nextTick(async () => {
      if (tab === 'garantia') {
        //
      }
    })
  }

  get isEdit() {
    return this.getRegrasDeCalculoStore.modeModalGarantiaMinima === 'EDIT'
  }

  loadCloseButton: boolean = false
  get loadingCloseButton() { return this.loadCloseButton }
  set loadingCloseButton(value: boolean) { this.loadCloseButton = value }

  loadFecharButton: boolean = false
  get loadingFecharButton() { return this.loadFecharButton }
  set loadingFecharButton(value: boolean) { this.loadFecharButton = value }

  async closeModal() {
    this.loadingCloseButton = true
    this.showModal = false
    this.getRegrasDeCalculoStore.clearRegraGarantiaMinimaItem()
    this.getRegrasDeCalculoStore.setModeModalGarantiaMinima('CREATE')
    await this.getRegrasDeCalculoStore.getRegrasGarantiaMinima(this.getRegrasDeCalculoStore.paginacaoGarantiaMinima)
    this.loadingCloseButton = false
  }

  @Watch('showModal')
  async onShowModalFinanceiroRegraDeCalculo(value: boolean) {
    if (value) {
      this.$refs.tabs.callSlider()
    }

    if (!value) {
      this.getRegrasDeCalculoStore.setMode('CREATE')
      this.tabs = 'tab-1'
    }
  }
}
